import { type MailboxInfo } from 'owa-client-types';
import { getNestedAppAuthExecutorFromCache } from './executeNaaRequestForMailboxInfo';
import type {
    NestedAppAuthExecutorConstructor,
    NestedAppAuthPrefetchRequest,
} from 'owa-nested-app-auth-types';
import { getGuid } from 'owa-guid';

export function prefetchNaaRequestForMailboxInfo(
    Executor: NestedAppAuthExecutorConstructor,
    mailboxInfo: MailboxInfo,
    request: NestedAppAuthPrefetchRequest,
    host: string,
    scenarioName: string
): void {
    const executor = getNestedAppAuthExecutorFromCache(Executor, mailboxInfo);

    if (executor) {
        executor.prefetchToken(
            {
                ...request,
                correlationId: getGuid(),
            },
            host,
            scenarioName
        );
    }
}
